<template>
    <div id="app" style="overflow: hidden;">
        <!--        <img src="./assets/img/updateImg/logo.svg" alt="" class="mark">-->
        <img :src="configJson.CONFIG[baseUrl.DOMAIN_URL].loginLogo" class="mark" alt/>
        <div class="mainCont">
            <div style="width: 20px;display: none">
                <img style="width: 100%" v-for="task in $imgJson.taskAiImgArr" :src="task" alt="">
                <img style="width: 100%" v-for="hand in $imgJson.handAiImgArr" :src="hand" alt="">
                <img src="./assets/img/navImg/nav1.svg" alt="">
                <img src="./assets/img/navImg/nav4.svg" alt="">
                <img src="./assets/img/navImg/nav5.svg" alt="">
                <img src="./assets/img/navImg/nav6.svg" alt="">
                <img src="./assets/img/navImg/nav7.svg" alt="">
                <img src="./assets/img/navImg/nav8.svg" alt="">
                <img src="./assets/img/navImg/nav9.svg" alt="">
                <img src="./assets/img/navImg/nav10.svg" alt="">
                <img src="./assets/img/navImg/nav19.svg" alt="">
                <img src="./assets/img/navImg/nav3.svg" alt="">
                <img src="./assets/img/navImg/nav18.svg" alt="">
                <img src="./assets/img/navImg/nav11.svg" alt="">
                <img src="./assets/img/navImg/nav12.svg" alt="">
                <img src="./assets/img/navImg/nav17.svg" alt="">
                <img src="./assets/img/navImg/nav2.svg" alt="">
                <img src="./assets/img/navImg/nav16.svg" alt="">
                <img src="./assets/img/navImg/nav15.svg" alt="">
                <img src="./assets/img/navImg/nav14.svg" alt="">
                <img src="./assets/img/navImg/nav13.svg" alt="">

                <img src="./assets/img/navImg/aphv.svg" alt="">
                <img src="./assets/img/navImg/speed.svg" alt="">
                <img src="./assets/img/navImg/antro.svg" alt="">
                <img src="./assets/img/navImg/yoyo.svg" alt="">
                <img src="./assets/img/navImg/agility.svg" alt="">
            </div>
            <router-view :style="{'width':AIimgType?'75%':'100%'}"
                         style="height: 100%;display: inline-block"></router-view>
            <div class="imgAi" v-show="AIimgType">
                <!--            <img src="./assets/img/taskAi/01.png" alt="">-->
                <img :src="imgUrl" alt="">
            </div>
        </div>
        <p class="prompt" v-show="$route.name!='Home' && $route.name!='Login'">
            <img src="./assets/img/reportImg/promptIcon.png" alt="">
            <span>你可以说： 紫禁勇士，{{ this.$store.state.promptMsg }}</span>
        </p>

        <p class="backBtn" v-show="$route.name!='Home' && $route.name!='Login' && $route.name!='teams'" @click="backFn">
            <img src="./assets/img/back.svg" alt="">
        </p>

        <div class="audioBox">
            <audio class="audio" id="audioDom"></audio>
        </div>

    </div>
</template>
<script>
import baseUrl from './config'; // 这里设置了一个文件作为所有请求的基础ip地址
//语音AI
import {Any} from 'google-protobuf/google/protobuf/any_pb';
import {
    AudioChunkContent,
    AudioFormatContent,
    AudioSpeechRecognitionResultContent,
    RealTimeChatMessage,
    RealTimeChatMessageOperationType,
    RealTimeChatMessageType,
} from './assets/js/generated/RealTimeChatService_pb'
// import { RealTimeChatServiceClient } from './generated/RealTimeChatServiceServiceClientPb.ts';
import * as pcm from './assets/js/utils/pcm_utils.ts';

export default {
    name: 'Home',
    data() {
        return {
            audioUrl: '',//ai语音流
            audioType: false,//语音是否播放完

            AIimgType: true,//ai人物是否显示
            //人物动画
            imgUrl: this.$imgJson.taskAiImgArr[0],
            timer: null,//定时器,

            //AI.json
            ws: null,////实现WebSocket
            record: null, //多媒体对象，用来处理音频
            command: null,//最新语音汉字
            lastCommandUpdate: null,//最新语音汉字的时间
            triggerAiDate: null,//触发ai语语音的时间
            askNum: 0,//询问次数 大于三次自动退出语音助手
            numOfAudioPacketsSent: 0,
            audioFormat: 'N/A',
            audioFormatRtcProto: null,
            targetPcmFormat: {
                channels: 1,
                sampleRate: 16000,
                bitDepth: 16,
            },
        }
    },
    computed: {
        flagFn() {
            return this.$store.state.flag;
        }
    },
    created() {
        if (this.$route.name == null) {
            this.$router.push({
                path: '/',
                name: 'Home'
            });
        }
    },
    watch: {
        $route(val, old) {
            if (val.name == "Home") {
                this.closeAi();
                this.storeInfo();
            }
            //判断路由 ai小人是否显示
            if (val.name == 'Login' || val.name == 'injuryDetail') {
                this.AIimgType = false
            } else {
                this.AIimgType = true
            }
            this.$store.state.promptMsg = val.meta.promptMsg;//提示

            if (val.name == 'Login') {
                this.storeInfo();
                this.info();//初始调用语音监听
            }

        },
        command: {
            handler(value, oldValue) {
                console.info('value changed 2', value);
                let ms = 60000 * 2;//间隔两分钟主动询问
                // let ms = 10000;//间隔两分钟主动询问
                let flag = 0;//是否触发全局指令 比如 退出，返回
                if (value !== oldValue) {
                    let globalRouse = this.$aiJson.globalRouse;//唤醒词
                    let back = this.$aiJson.back;//返回
                    let exit = this.$aiJson.exit;//退出
                    let backMain = this.$aiJson.backMain;//返回到首页
                    let backTeam = this.$aiJson.backTeam;//返回到梯队页面
                    globalRouse.some((item) => {
                        if (eval('/' + item + '/gi').test(value)) {//触发紫禁勇士判断
                            this.askNum = 0;//询问次数归0
                            if (this.$route.name != 'Home') {
                                for (let i = 0; i < backMain.length; i++) {
                                    if (eval('/' + backMain[i] + '/gi').test(value)) {//触发返回到首页
                                        this.$children[0].teamNameFlag = false
                                        this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                                        if (this.$route.name != 'main_btn') {
                                            this.$store.dispatch("setRouter", {
                                                path: '/about/main_btn',
                                                name: 'main_btn',
                                                goType: 1
                                            });//vuex改变路由
                                        }
                                        flag = 1;
                                        return;
                                    } else {
                                        flag = 0
                                    }
                                }
                                for (let i = 0; i < backTeam.length; i++) {
                                    if (eval('/' + backTeam[i] + '/gi').test(value)) {//触发返回到梯队
                                        this.$children[0].teamNameFlag = false
                                        this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                                        if (this.$route.name != 'teams') {
                                            this.$store.dispatch("setRouter", {
                                                path: '/teams',
                                                name: 'teams',
                                                goType: 1
                                            });//vuex改变路由
                                        }
                                        flag = 1;
                                        return;
                                    } else {
                                        flag = 0
                                    }
                                }
                                for (let i = 0; i < back.length; i++) {
                                    if (eval('/' + back[i] + '/gi').test(value)) {//触发返回
                                        this.$children[0].teamNameFlag = false
                                        this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                                        if (this.$route.name != 'teams') {
                                            this.$store.dispatch("setRouter", {
                                                path: null,
                                                name: null,
                                                goType: -1,
                                                params: this.$route.params
                                            });//vuex改变路由
                                            this.$store.state.teamName != '' ? this.$store.state.teamName = this.$store.state.teamName.split('_')[0] + '_' + new Date().getTime() : '';
                                            this.$store.state.backFlag = true;//返回触发
                                        } else {
                                            this.$store.dispatch("setRouter", {
                                                path: '/',
                                                name: 'Home',
                                                goType: 1,
                                                params: this.$route.params
                                            });//vuex改变路由
                                        }

                                        flag = 1;
                                        return;
                                    } else {
                                        flag = 0
                                    }
                                }
                                for (let j = 0; j < exit.length; j++) {
                                    if (eval('/' + exit[j] + '/gi').test(value)) {//触发退出
                                        this.$store.dispatch("setFlag", '3_' + new Date().getTime());//vuex改变识别信息
                                        this.$store.dispatch("setRouter", {path: '/', name: 'Home', goType: 1});//vuex改变路由
                                        flag = 1;
                                        return;
                                    } else {
                                        if (!flag) {
                                            flag = 0
                                        }
                                    }
                                }
                            }


                            if (!flag) {
                                this.$store.dispatch("setParamsCommand", value);
                            }
                            return true;
                        }
                    })
                }
                if ((this.lastCommandUpdate - this.triggerAiDate > ms) && this.$route.name != 'Home' && this.$route.name != 'smartPitchCamera') {
                    this.askNum = this.askNum + 1;
                    if (this.askNum <= 2) {//提示文字--提示用户语音还在继续
                        this.$store.dispatch("setFlag", '2_' + new Date().getTime());//vuex改变识别信息
                    } else if (this.askNum == 3) {//自动退出
                        this.$store.dispatch("setFlag", '3_' + new Date().getTime());//vuex改变识别信息
                        this.$store.dispatch("setRouter", {path: '/', name: 'Home', goType: 1});//vuex改变路由
                    }
                }
            },
            deep: true
        },
        flagFn: {//全局回应 比如 好的或没听清
            handler(val, old) {
                if (val.split('_')[0] == 1) {//好的--跳转页面
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.identify)), false, true);
                } else if (val.split('_')[0] == 2) {//提示还在继续
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.idle)), true, true);
                } else if (val.split('_')[0] == 3) { //自动退出
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.exit)), false, true);
                } else if (val.split('_')[0] == 0) {//没听清
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.notIdentify)), true, true);
                } else if (val.split('_')[0] == 4) {//登录成功
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.loginSuccess)), false, true);
                } else if (val.split('_')[0] == 5) {//识别到人脸
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.faceMsg)), false, true);
                } else if (val.split('_')[0] == 6) {//选择登录的用户提示
                    this.audioPlayFn(this.$global.audioPlayUrl(this.$global.randomFn(this.$aiJson.playVoice.loginMsg)), true, true);
                }
            },
            deep: true
        },
        audioType: {
            handler(val, old) {
                if (val) {
                    let dom = document.querySelector('audio');
                    dom != null ? dom.play() : '';
                }
            },
            deep: true
        }
    },
    mounted() {
        // if (this.$route.name == 'Login') {
        //     this.storeInfo();
        //     this.info();//初始调用语音监听
        // }
    },
    methods: {
        //播放获取到的语音流
        audioPlayFn(url, flag, aiPeoPlay) {
            //flag --true播放完继续打开WebSocket --false播放完不再打开
            //aiPeoPlay--true ai说话动画执行
            console.log('开始播放');
            this.audioUrl = url;
            this.closeAi();//关闭WebSocket
            // let dom = document.getElementById('audioDom');
            let audio = document.getElementById('audioDom')
            audio.play();
            audio.controls = false  //这样控件才能显示出来
            audio.src = this.audioUrl  //音乐的路径
            audio.webkitPlaysinline = true
            audio.playsinline = true
            // document.body.appendChild(audio)
            audio.play()
            // this.audioType = false;

            if (aiPeoPlay && this.$route.name != 'Login') {
                let taskMes = this.$global.GetQueryString('text', url)
                let aiPeoPlayTime = ((this.$global.strLength(taskMes) / 6) / 1.6) < 1 ? Math.ceil((this.$global.strLength(taskMes) / 6) / 1.6) : Math.round((this.$global.strLength(taskMes) / 6) / 1.6);
                clearInterval(this.$children[0].timer);
                this.imgAi(this.$imgJson.taskAiImgArr, aiPeoPlayTime)
                // this.imgAi(this.$imgJson.handAiImgArr,aiPeoPlayTime)
            } else {
                this.askNum = 0;//询问次数归0
            }
            if (flag) {
                this.info();
            } else {
                let store = this.$store.state;
                console.log(store.router)
                if (store.router.goType > 0) {
                    if (store.router.name != this.$route.name) {
                        this.$router.push(store.router)
                    }
                } else if (store.router.goType < 0) {
                    this.$router.go(-1);
                }

                // if (this.$store.state.flag.split('_')[0] == 3) {
                //     this.info();
                // }
            }
            // document.body.removeChild(audio);
            // this.audioType = true;
            this.triggerAiDate = new Date();
        },
        //AI语音功能
        init(rec) {
            this.record = rec;
        },
        handleSrResult(content) {
            const isIntermediate = content.getIsintermediate();
            const srResult = content.getText().trim();
            if (!isIntermediate) {
                console.log(`srResult: (${isIntermediate}) ${srResult}`);
                this.command = srResult + '_' + new Date().getTime();
                this.lastCommandUpdate = new Date();
            }
        },
        reconnectedIfNeeded() {
            if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
                return;
            }
            try {
                this.ws?.close();
            } catch (e) {
                console.error(e);
            }
            this.ws = new WebSocket(baseUrl.DOMAIN_NAME.AI_URL + "/rtc");
            this.bindWebSocketEventListeners()
        },
        bindWebSocketEventListeners() {
            if (this.ws) {
                this.ws.onmessage = this.webSocketOnMessage;
                this.ws.onopen = this.webSocketOnOpen;
                this.ws.onerror = this.webSocketOnError;
                // this.ws.onclose = this.webSocketOnClose;
            }
        },
        webSocketOnMessage(evt) {
            const blob = evt.data;
            const fileReader = new FileReader();
            // console.log(blob)
            fileReader.readAsArrayBuffer(blob);
            fileReader.onload = () => {
                const message = RealTimeChatMessage.deserializeBinary(new Uint8Array(fileReader.result));
                // console.log(message.getType());
                if (message.getType() === RealTimeChatMessageType.AUDIORESPONSE) {
                    // console.log(message.getContent());
                    // const content = message
                    //     .getContent()
                    //     .unpack(
                    //         AudioResponseContent.deserializeBinary,
                    //         'RealTimeChat.AudioResponseContent',
                    //     ) as AudioResponseContent;

                    // const text = content.getText();
                    // console.log(`text: ${text}`);
                    // self.audioPlayUrl = content.getAudiourl();
                    // console.log(self.audioPlayUrl);
                    // const audioTag = document.getElementById('audio_player') as HTMLAudioElement;
                    // audioTag.play();
                } else if (message.getType() === RealTimeChatMessageType.AUDIOSPEECHRECOGNITIONRESULT) {
                    const content = message
                        .getContent()
                        .unpack(
                            AudioSpeechRecognitionResultContent.deserializeBinary,
                            'RealTimeChat.AudioSpeechRecognitionResultContent',
                        );
                    // console.log(content)
                    this.handleSrResult(content);
                } else if (message.getType() === RealTimeChatMessageType.INTERRUPSIGNAL) {
                    // self.audioPlayUrl = '';
                }
            };
        },
        webSocketOnOpen() {
            this.useWebSocket(this.audioFormatRtcProto);
            console.log('audio format sent');
            // console.log(this.audioFormatRtcProto);
        },
        webSocketOnError() {
            console.log('error');
        },
        webSocketOnClose() {
            if (this.$route.name == 'Home') {
                console.log('close');

            }
        },
        useWebSocket(message) {
            // ws = new WebSocket("wss://10.0.0.10/wsapi/rtc");
            // ws.binaryType = 'arraybuffer'; //传输的是 ArrayBuffer 类型的数据
            this.reconnectedIfNeeded();
            // console.log(WebSocket.OPEN)
            // console.log(ws.readyState)
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                // console.log(message.serializeBinary().buffer)
                this.ws.send(message.serializeBinary().buffer);
            }
        },
        //初始化调用ai
        info() {
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
            if (!navigator.getUserMedia) {
                alert('浏览器不支持音频输入');
            } else {
                navigator.getUserMedia({
                        audio: true
                    },
                    (stream) => {
                        // console.log(mediaStream)
                        let that = this;
                        var Recorder = function (stream) {
                            var sampleBits = 16; //输出采样数位 8, 16
                            var sampleRate = 48000; //输出采样率
                            var context = new AudioContext();
                            var audioInput = context.createMediaStreamSource(stream);
                            var recorder = context.createScriptProcessor(4096, 1, 1);
                            var audioData = {
                                size: 0, //录音文件长度
                                buffer: [], //录音缓存
                                inputSampleRate: 16000, //输入采样率
                                inputSampleBits: 16, //输入采样数位 8, 16
                                outputSampleRate: sampleRate, //输出采样数位
                                oututSampleBits: sampleBits, //输出采样率
                                clear: function () {
                                    this.buffer = [];
                                    this.size = 0;
                                },
                                input: function (data) {
                                    this.buffer.push(new Float32Array(data));
                                    this.size += data.length;
                                },
                                compress: function () { //合并压缩
                                    //合并
                                    var data = new Float32Array(this.size);
                                    var offset = 0;
                                    for (var i = 0; i < this.buffer.length; i++) {
                                        data.set(this.buffer[i], offset);
                                        offset += this.buffer[i].length;
                                    }
                                    //压缩
                                    var compression = parseInt(this.inputSampleRate / this.outputSampleRate);
                                    var length = data.length / compression;
                                    var result = new Float32Array(length);
                                    var index = 0,
                                        j = 0;
                                    while (index < length) {
                                        result[index] = data[j];
                                        j += compression;
                                        index++;
                                    }
                                    return result;
                                },
                                encodePCM: function () { //这里不对采集到的数据进行其他格式处理，如有需要均交给服务器端处理。
                                    var sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate);
                                    var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
                                    var bytes = this.compress();
                                    var dataLength = bytes.length * (sampleBits / 8);
                                    var buffer = new ArrayBuffer(dataLength);
                                    var data = new DataView(buffer);
                                    var offset = 0;
                                    for (var i = 0; i < bytes.length; i++, offset += 2) {
                                        var s = Math.max(-1, Math.min(1, bytes[i]));
                                        data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                                    }
                                    return new Blob([data]);
                                }
                            };

                            var sendData = (message) => { //对以获取的数据进行处理(分包)

                                if (message != null) {
                                    that.useWebSocket(message);
                                }
                                audioData.clear();//每次发送完成则清理掉旧数据
                            };

                            this.start = () => {
                                audioInput.connect(recorder);
                                recorder.connect(context.destination);
                            }

                            this.stop = () => {
                                recorder.disconnect();
                            }

                            this.getBlob = () => {
                                return audioData.encodePCM();
                            }

                            var clear = () => {
                                audioData.clear();
                            }

                            recorder.onaudioprocess = function (e) {
                                // var inputBuffer = e.inputBuffer.getChannelData(0);
                                var inputBuffer = e.inputBuffer;
                                if (!that.audioFormatRtcProto) {
                                    const rawAudioFormat = {
                                        float: true,
                                        channels: inputBuffer.numberOfChannels,
                                        sampleRate: inputBuffer.sampleRate,
                                        interleaved: false,
                                        bitDepth: inputBuffer.bitDepth,
                                    };
                                    that.audioFormat = JSON.stringify(rawAudioFormat);
                                    const audioFormatProto = new AudioFormatContent();
                                    audioFormatProto.setChannels(rawAudioFormat.channels);
                                    audioFormatProto.setBitdepth(rawAudioFormat.bitDepth);
                                    audioFormatProto.setSamplerate(rawAudioFormat.sampleRate);
                                    // console.log(audioFormatProto);

                                    const messageProto = new RealTimeChatMessage();
                                    messageProto.setType(RealTimeChatMessageType.AUDIOFORMAT);
                                    messageProto.setOperationtype(RealTimeChatMessageOperationType.INFORM);
                                    const content = new Any();
                                    content.pack(audioFormatProto.serializeBinary(), 'RealTimeChat.AudioFormatContent');
                                    messageProto.setContent(content);

                                    // console.log(messageProto);
                                    that.audioFormatRtcProto = messageProto;
                                }
                                const resampled = pcm.toArrayBuffer(inputBuffer, that.targetPcmFormat);
                                const audioChunkProto = new AudioChunkContent();
                                audioChunkProto.setData(new Uint8Array(resampled));
                                const messageProto = new RealTimeChatMessage();
                                messageProto.setType(RealTimeChatMessageType.AUDIOCHUNK);
                                messageProto.setOperationtype(RealTimeChatMessageOperationType.INFORM);
                                const content = new Any();
                                content.pack(audioChunkProto.serializeBinary(), 'RealTimeChat.AudioChunkContent');
                                messageProto.setContent(content);
                                // console.log(messageProto)
                                that.numOfAudioPacketsSent += 1;
                                audioData.input(inputBuffer);
                                sendData(messageProto);
                            }
                        }
                        that.init(new Recorder(stream));
                        console.log('开始对讲');
                        // console.log(that.record)
                        that.record.start();
                    },
                    function (error) {
                        console.log(error);
                        switch (error.message || error.name) {
                            case 'PERMISSION_DENIED':
                            case 'PermissionDeniedError':
                                console.info('用户拒绝提供信息。');
                                break;
                            case 'NOT_SUPPORTED_ERROR':
                            case 'NotSupportedError':
                                console.info('浏览器不支持硬件设备。');
                                break;
                            case 'MANDATORY_UNSATISFIED_ERROR':
                            case 'MandatoryUnsatisfiedError':
                                console.info('无法发现指定的硬件设备。');
                                break;
                            default:
                                console.info('无法打开麦克风。异常信息:' + (error.code || error.name));
                                break;
                        }
                    }
                )
            }
        },
        //关闭连接
        closeAi() {
            this.ws ? this.ws.close() : '';
            this.record ? this.record.stop() : '';
        },
        //ai人物动画
        imgAi(img, time) {
            //type---1一次性动作  0默认动作
            let index = 0;
            let flag = 1;//1--正序播放 0---倒叙
            let num = 0;//setInterval执行了几次
            this.imgUrl = img[0];
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (flag) {
                    index++;
                    if (index >= img.length) {
                        flag = 0;
                    } else {
                        this.imgUrl = img[index];
                    }
                } else {
                    index--;
                    if (index < 0) {
                        flag = 1;
                    } else {
                        this.imgUrl = img[index];
                    }
                }
                num++
                if (time) {
                    if ((num / (img.length * 2)) >= time) {
                        clearInterval(this.timer);
                    }
                } else {
                    if (num >= img.length * 2) {
                        clearInterval(this.timer);
                    }
                }
            }, time ? 80 : 50);
        },
        handImgGif(img) {
            this.imgUrl = img;
        },
        //vuex初始化
        storeInfo() {
            this.$store.dispatch('setUserName', null)
            this.$store.dispatch('setTeamName', null)
            this.$store.dispatch('setRouter', {path: null, name: null, goType: null})
            this.$store.dispatch('setLookDetail', null)
            this.$store.dispatch('setParamsCommand', null)
        },
        backFn() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="less">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative;
}

:root {
    --primary-color: #A75CE7;
}


.mainCont {
    z-index: 300;
    position: absolute;
    top: 12%;
    left: 4%;
    /*bottom: 0;
    right: 0;
    transform: translate(-2% 2%);
    -webkit-transform: translate(-2%, 2%);*/
    width: 92%;
    height: 84%;
    display: flex;
}

.mark {
    position: fixed;
    top: 2.5vw;
    left: 2vw;
    z-index: 1000;
    width: 14%;
}

.imgAi {
    width: 25%;
    min-width: 20%;
    /*position: relative;*/
    /*overflow: hidden;*/
    display: inline-block;
    height: 100%;
    float: right;
    position: fixed;
    right: 2%;
    bottom: 70px;
    /*z-index: 700;*/

    img {
        /*height: 60%;*/
        width: 98%;
        margin-top: 20%;
        position: absolute;
        bottom: -0%;
        left: -10%;
    }
}


.prompt {
    width: 100%;
    /*background: rgba(12, 12, 13, .5);*/
    height: 2vw;
    text-align: center;
    line-height: 2vw;
    border-radius: 1vw;
    position: absolute;
    color: #fff;
    bottom: 2vw;
    padding-left: .5vw;
    z-index: 10000;
    margin: 0 auto;

    img {
        /*margin-top: .2vw;*/
        /*float: left;*/
        /*display: inline-block;*/
    }

    span {
        font-size: 18px;
        /*margin-top: 0.1vw;*/
        /*float: left;*/
        padding-left: 1vw;
        display: inline-block;
    }
}

.backBtn {
    position: absolute;
    left: 0;
    top: calc((100% - 10vw) / 2);
    height: 6vw;
    width: 2.5vw;
    z-index: 999;

    img {
        width: 100%;
    }

}
</style>
